import { DeleteOutlined } from '@ant-design/icons';
import { Col, Modal, Row, Space } from 'antd';

import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import { OverviewCard } from './overview-card/overview-card';
import { useOverviewPage } from './overview.page-hook';

export const OverviewPage = () => {
  const { applications, handleDelete, isOpen, showModal, closeModal, setId, isLoading } = useOverviewPage();

  return (
    <>
      <PageWrapper>
        <PageTitle>Overview</PageTitle>
        <Row gutter={[24, 24]}>
          {applications.map((application) => (
            <Col key={application.id} span={12}>
              <OverviewCard
                application={application}
                onDelete={() => {
                  setId(application.id);
                  showModal();
                }}
              />
            </Col>
          ))}
        </Row>
      </PageWrapper>
      <Modal
        open={isOpen}
        title='Delete application'
        footer={
          <Space direction='horizontal'>
            <Button key='back' type={ButtonTypeEnum.Primary} ghost onClick={closeModal}>
              Cancel
            </Button>
            <Button loading={isLoading} type={ButtonTypeEnum.Error} ghost onClick={handleDelete}>
              <DeleteOutlined />
              <Text color={ColorEnum.Red6} letterSpacing={1.4}>
                Delete
              </Text>
            </Button>
          </Space>
        }
        onCancel={closeModal}
      >
        <Text level='m' paragraph>
          Are you sure you want to delete this application? <br />
          <br />
          This action is irreversible, and all data associated with the application will be permanently deleted.
        </Text>
      </Modal>
    </>
  );
};
